document.addEventListener('DOMContentLoaded', function() {
  const parentElement = document.querySelector(`.product-form-wrapper`);
  const rechargeSubForm = document.querySelector(`.shopify-block.shopify-app-block.recharge-subscription-widget`);
  parentElement.insertBefore(rechargeSubForm, parentElement.firstChild);
  setTimeout(() => {
    console.log(`DOMContentLoaded - setTimeout`)

    const deliveryOptionsElement = document.querySelector(`.product-form-wrapper .shopify-block.shopify-app-block.recharge-subscription-widget .rc-widget .rc-template__radio .rc-selling-plans select.rc-selling-plans-dropdown__select`);
    const subscriptionsTitleElement = document.querySelector(`.product-form-wrapper .shopify-block.shopify-app-block.recharge-subscription-widget .rc-widget .rc-template__radio label.rc-radio.px-3.py-2 .rc-radio__label .rc-radio__subscription`);
    const subscriptionBox = document.querySelector(`.product-form-wrapper .shopify-block.shopify-app-block.recharge-subscription-widget .rc-widget .rc-template__radio label.rc-radio.px-3.py-2 .rc-radio__label`);
    const priceBox = document.querySelector(`.product-form-wrapper .shopify-block.shopify-app-block.recharge-subscription-widget .rc-widget .rc-template__radio label.rc-radio.px-3.py-2 .rc-radio__label .rc-radio__price`);

    for (let optionI in deliveryOptionsElement.options) {
      if (deliveryOptionsElement.options.hasOwnProperty(optionI)) {
        let optionText = deliveryOptionsElement.options[optionI].text.split(' subscription');
        deliveryOptionsElement.options[optionI].text = optionText[0];
      }
    }

    const rcSelectDivOut = document.createElement(`div`);
    rcSelectDivOut.classList.add('rc-select-out');
    rcSelectDivOut.appendChild(subscriptionsTitleElement);

    const deliveryTitle = document.createElement(`div`);
    deliveryTitle.classList.add('rc-delivery-title');
    deliveryTitle.innerHTML = 'Delivery every';

    const rcSelectDiv = document.createElement(`div`);
    rcSelectDiv.classList.add('rc-select-div');
    rcSelectDiv.appendChild(deliveryTitle);
    rcSelectDiv.appendChild(deliveryOptionsElement);

    rcSelectDivOut.appendChild(rcSelectDiv);

    subscriptionBox.appendChild(rcSelectDivOut);
    subscriptionBox.appendChild(priceBox);

  }, 500);
});
